<template>
    <div class="modal-mask" @click.self="$emit('close')">
        <div class="modal-wrapper">
            <div class="modal-container">
                <div class="modal-header">
                    <slot name="header">
                        <a
                            class="material-icons modal-default-button"
                            @click="$emit('close')"
                            >close</a
                        >
                    </slot>
                </div>
                <div class="modal-body">
                    <slot name="body"> default body </slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Modal",
    props: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
